export interface QuestionInfoProps {
  question: SurveyQuestionMultipleChoiceEntity;
}

export default function QuestionInfo({ question }: QuestionInfoProps) {
  const text = getInfoText(question);
  return <span className="text-[13px] text-orange-500 font-medium">{text}</span>;
}

function getInfoText(q: SurveyQuestionMultipleChoiceEntity) {
  if (!q.allowMultipleSelect) return <></>;
  if (q.maxSelectableChoices === q.minSelectableChoices) {
    if (q.maxSelectableChoices === 1) return <></>;
    return `${q.maxSelectableChoices} گزینه را انتخاب کنید`;
  }
  if (q.minSelectableChoices === 1) {
    return `حداکثر ${q.maxSelectableChoices} گزینه را انتخاب کنید`;
  }
  return `حداقل ${q.minSelectableChoices} گزینه و حداکثر ${q.maxSelectableChoices} گزینه را انتخاب کنید`;
}
